import { Component, OnInit } from '@angular/core';
import { Zona } from '../../_models/zona';
import { EstructuraFisica } from '../../_models/estructura-fisica';
import { EstructuraFisicaService } from '../../_services/estructura-fisica.service';
import { ZonaService } from '../../_services/zona.service';
import { AgendasService } from '../../_services/agendas.service';
import { Agenda } from '../../_models/agenda';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { NavService } from '../../_services/_nav.service';
import { Localizaciones } from '../../_models/localizaciones';
import { LocalizacionesService } from '../../_services/localizaciones.service';
import { Dia } from '../../_models/dia';
import { Location } from '@angular/common';

@Component( {
  selector: 'app-agenda-detalle',
  templateUrl: 'agenda-detalle.component.html'
} )

export class AgendaDetalleComponent implements OnInit {

  zona: Zona = new Zona();
  estFisica: EstructuraFisica = new EstructuraFisica();
  agendas: Agenda[] = [];
  carInformacionInicial = true;
  columnas: any[] = [];
  localizacion: Localizaciones = new Localizaciones();
  dias: Dia[] = [];
  tabSeleccionado: string;

  constructor( private estFisicaServicio: EstructuraFisicaService,
               private zonServicio: ZonaService,
               private ageServicio: AgendasService,
               private route: ActivatedRoute,
               private location: Location,
               private navServicio: NavService, private locServicio: LocalizacionesService) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'barrio', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_BARRIOPRINCIPAL' ), sort: true },
      { field: 'indicadorDividirBarrio', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_DIVICIONDEBARRIO' ), sort: true }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        forkJoin( this.zonServicio.get( params[ 'id' ] ),
          this.ageServicio.obtenerPorZona( params[ 'id' ] ) ).subscribe( ( [ zona, agendas ] ) => {
          this.zona = zona;
          this.agendas = agendas.filter( x => x.indicadorHabilitado );
          this.cargarDias();
          this.estFisicaServicio.getById( this.zona.idEstructuraFisica ).subscribe( estructura => {
            this.estFisica = estructura;
            if ( this.estFisica.idLocalizacion !== null && this.estFisica.idLocalizacion !== '' && this.estFisica.idLocalizacion !== undefined ) {
              this.locServicio.getById( this.estFisica.idLocalizacion, true ).subscribe( localizacion => {
                this.localizacion = localizacion;
              } );
            }
            this.carInformacionInicial = false;
          } );
        } );
      }
    } );

  }

  cargarDias() {
    this.dias.push( new Dia( 'L', 'AGENDA.LBL_LUNES', null, null, null, false, 'indicadorLunes' ) );
    this.dias.push( new Dia( 'M', 'AGENDA.LBL_MARTES', null, null, null, false, 'indicadorMartes' ) );
    this.dias.push( new Dia( 'MI', 'AGENDA.LBL_MIERCOLES', null, null, null, false, 'indicadorMiercoles' ) );
    this.dias.push( new Dia( 'J', 'AGENDA.LBL_JUEVES', null, null, null, false, 'indicadorJueves' ) );
    this.dias.push( new Dia( 'V', 'AGENDA.LBL_VIERNES', null, null, null, false, 'indicadorViernes' ) );
    this.dias.push( new Dia( 'S', 'AGENDA.LBL_SABADO', null, null, null, false, 'indicadorSabado' ) );
    this.dias.push( new Dia( 'D', 'AGENDA.LBL_DOMINGO', null, null, null, false, 'indicadorDomingo' ) );
    this.tabSeleccionado = this.dias[ 0 ].codigo;
    this.dias.map( ( d: Dia ) => {
      d.datos = this.agendas.filter( x => x[ d.indicador ] );
    } );
  }

  regresar() {
    this.location.back();
  }

}
